import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { StripeV2CoinsPrice } from '@/services/stripe/dto';

import './Description.scss';

export const Description: React.FC<{
  product: StripeV2CoinsPrice;
}> = ({ product }) => {
  return (
    <div className="payment-description">
      <div className="payment-description__row">
        <UiTypography variant="body-medium">{product.label} Plan</UiTypography>
        <UiTypography variant="body-medium">${product.price}</UiTypography>
      </div>
      {/* 
      <div className="payment-description__row">
        <UiTypography variant="body-medium">Discount</UiTypography>
        <UiTypography variant="body-medium" color="danger">
          -${sale}
        </UiTypography>
      </div> */}

      <div className="payment-description__total">
        <UiTypography variant="title-large">Total</UiTypography>
        <UiTypography variant="title-large">${product.price}</UiTypography>
      </div>
    </div>
  );
};
